import start from './src/start';

import brk_single_elimination from '../../../brackets/js/single-elimination-brackets';
import brackets_shared_config from '../../brackets-esy/js/brk-esy-shared-settings';
import get_brackets_data from '../../brackets-esy/js/brk-esy-get-data';
import info_popup, {info_popup_listeners, close_infobox} from '../../brackets-esy/js/brk-esy-info-popup';
import {overlay, remove_overlay} from '@massimo-cassandro/m-utilities/js-utilities/overlay';

start();

const bracket_container = document.getElementById('brk-esy-container');

// il bracket è generato solo a partita iniziata
if(bracket_container) {
  const torneo_id = +bracket_container.dataset.id;

  let first_run = true;
  const run_brackets = () => {

    get_brackets_data(torneo_id).then(data => {
      brk_single_elimination({
        container   : bracket_container,
        members     : data.members,
        matches     : data.matches,
        config      : {
          ...brackets_shared_config,
          ...data.config,    // dal json del torneo
          player_cbk_selector : '.brk-match .brk-match-player:not([data-pid=""])',
          player_callback     : info_popup
        }
      });

      if(first_run) {
        info_popup_listeners();
        first_run = false;
      }
    });
  };

  run_brackets();
  setInterval(() => {
    overlay(bracket_container);
    close_infobox();
    run_brackets();
    remove_overlay(bracket_container);
  }, 60 * 1000 * 5);
}
